import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './NotFound.css';

const NotFound = () => {
  return (
    <>
      <Navbar />
      <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-message">Page not found</p>
        <p className="not-found-hint">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="not-found-link">
          Go to Home
        </Link>
      </div>
    </div>
      <Footer />
    </>
  );
};

export default NotFound;
